import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricBadge = ({ label, value, trend, color }) => (
  <div className={`bg-${color}-50 border border-${color}-200 rounded-lg p-3 flex flex-col gap-1`}>
    <span className="text-xs text-gray-500 font-medium">{label}</span>
    <span className={`text-lg font-bold text-${color}-700`}>{value}</span>
    {trend && (
      <span className={`text-xs flex items-center gap-1 ${trend?.startsWith('+') ? 'text-green-600' : 'text-red-500'}`}>
        <Icon name={trend?.startsWith('+') ? 'TrendingUp' : 'TrendingDown'} size={11} />
        {trend} YoY
      </span>
    )}
  </div>
);

const ExecutiveSummary = ({ report, emirate, period }) => {
  if (!report) return null;

  const metrics = report?.metrics || {};
  const summary = report?.executiveSummary || '';
  const keyHighlights = report?.keyHighlights || [];

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 bg-emerald-100 rounded-lg flex items-center justify-center">
          <Icon name="FileText" size={16} className="text-emerald-600" />
        </div>
        <div>
          <h2 className="font-bold text-gray-900 text-base">Executive Summary</h2>
          <p className="text-xs text-gray-500">{emirate === 'all' ? 'All Emirates' : emirate} · {period}</p>
        </div>
        <span className="ml-auto bg-emerald-100 text-emerald-700 text-xs font-semibold px-2.5 py-1 rounded-full">AI Generated</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
        <MetricBadge label="Median Price" value={metrics?.medianPrice || 'N/A'} trend={metrics?.medianPriceTrend} color="blue" />
        <MetricBadge label="YoY Growth" value={metrics?.yoyGrowth || 'N/A'} trend={metrics?.yoyGrowth} color="green" />
        <MetricBadge label="Transactions" value={metrics?.transactions || 'N/A'} trend={metrics?.transactionsTrend} color="purple" />
        <MetricBadge label="Avg Price/sqft" value={metrics?.pricePerSqft || 'N/A'} trend={metrics?.pricePerSqftTrend} color="orange" />
      </div>
      <div className="prose prose-sm max-w-none text-gray-700 leading-relaxed mb-4">
        {summary?.split('\n')?.map((para, i) => para?.trim() && <p key={i} className="mb-2">{para}</p>)}
      </div>
      {keyHighlights?.length > 0 && (
        <div className="bg-gray-50 rounded-lg p-4">
          <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2">Key Highlights</p>
          <ul className="space-y-1.5">
            {keyHighlights?.map((h, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-gray-700">
                <Icon name="CheckCircle" size={14} className="text-emerald-500 mt-0.5 flex-shrink-0" />
                {h}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ExecutiveSummary;
